__webpack_require__.p = "/pharma/";